import { Badge } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { SingleTransactionResponseType } from '@/features/slice/accounting/transaction';
import { formatCurrencyInBDT } from '@/utils';

export const transactionsReportColumns: ColumnDef<SingleTransactionResponseType>[] =
    [
        {
            accessorKey: 'created_at',
            header: () => <div>Created At</div>,
            cell: ({ row }) => (
                <div>
                    {format(row.original.created_at, 'dd-MM-yyyy HH:mm a')}
                </div>
            ),
        },

        {
            accessorKey: 'amount',
            header: () => <div className={'text-right'}>Amount</div>,
            cell: ({ row }) => (
                <div className={'text-right'}>
                    {formatCurrencyInBDT(row.original.amount ?? 0)}
                </div>
            ),
        },

        {
            accessorKey: 'type',
            header: () => <div className={'text-center'}>Type</div>,
            cell: ({ row }) => (
                <div className={'flex w-full items-center justify-center'}>
                    <Badge variant={'outline'}>{row.original.type}</Badge>
                </div>
            ),
        },

        {
            accessorKey: 'event_type',
            header: () => <div className={'text-center'}>Event Type</div>,
            cell: ({ row }) => (
                <div className={'flex w-full items-center justify-center'}>
                    <Badge variant={'outline'}>{row.original.event_type}</Badge>
                </div>
            ),
        },

        {
            accessorKey: 'note',
            header: () => <div>Note</div>,
            cell: ({ row }) => <div>{row.original.note}</div>,
        },
    ];
